/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {advanceSupportFlow} from '../api'

export const useMutationAdvanceSupportFlow = createReactQueryMutationHook('advanceSupportFlow', advanceSupportFlow)
